module.exports = __webpack_public_path__ + "img/cover.91ec1754.png";